// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-gradient: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  --card-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  --hover-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  --border-radius: 16px;
  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.profile-page {
  display: flex;
  min-height: 100vh;
  background: linear-gradient(180deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 0;
  gap: 0;
}

/* Mobile Menu Toggle */
.mobile-menu-toggle {
  display: none;
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 1001;
  width: 50px;
  height: 50px;
  border-radius: 12px;
  background: var(--primary-gradient);
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  align-items: center;
  justify-content: center;
  transition: var(--transition);
}

.mobile-menu-toggle:hover {
  transform: scale(1.05);
}

.mobile-menu-toggle:active {
  transform: scale(0.95);
}

/* Sidebar */
.profile-sidebar {
  width: 280px;
  min-height: 100vh;
  background: white;
  box-shadow: 4px 0 30px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
  flex-shrink: 0;
  z-index: 100;
  transition: var(--transition);
}

.sidebar-header {
  padding: 30px 24px;
  background: var(--primary-gradient);
  color: white;
  margin-bottom: 20px;
}

.sidebar-header h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
}

.sidebar-header p {
  margin: 8px 0 0;
  font-size: 13px;
  opacity: 0.9;
}

.sidebar-menu {
  background: transparent;
  overflow: visible;
  padding: 0 16px;
}

.sidebar-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  color: #64748b;
  text-decoration: none;
  transition: var(--transition);
  border-radius: 12px;
  margin-bottom: 6px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
}

.sidebar-item:hover {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  color: #667eea;
  transform: translateX(4px);
}

.sidebar-item.active {
  background: var(--primary-gradient);
  color: white;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.sidebar-item.active:hover {
  transform: translateX(4px);
}

.sidebar-icon {
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.05);
  transition: var(--transition);
}

.sidebar-item.active .sidebar-icon {
  background: rgba(255, 255, 255, 0.2);
}

.sidebar-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, #e2e8f0, transparent);
  margin: 16px 24px;
}

.sidebar-section-title {
  padding: 8px 24px;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #94a3b8;
  font-weight: 700;
}

/* Main Content */
.profile-main {
  flex: 1 1;
  min-width: 0;
  padding: 40px;
  max-width: calc(100% - 280px);
}

.profile-header {
  margin-bottom: 32px;
}

.profile-header h1 {
  margin: 0 0 10px;
  background: var(--primary-gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 36px;
  font-weight: 800;
  letter-spacing: -0.5px;
}

.profile-header p {
  margin: 0;
  color: #64748b;
  font-size: 16px;
}

.profile-content {
  background: white;
  border-radius: var(--border-radius);
  padding: 32px;
  box-shadow: var(--card-shadow);
}

/* Profile Picture */
.profile-picture-section {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 2px solid #f1f5f9;
}

.profile-picture-container {
  width: 120px;
  height: 120px;
  border-radius: 24px;
  overflow: hidden;
  flex-shrink: 0;
  border: 4px solid white;
  box-shadow: 0 8px 30px rgba(102, 126, 234, 0.3);
}

.profile-picture {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.profile-picture-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--primary-gradient);
  color: white;
  font-size: 48px;
  font-weight: 700;
}

.profile-picture-info h3 {
  margin: 0 0 6px;
  color: #1e293b;
  font-size: 28px;
  font-weight: 700;
}

.profile-picture-info p {
  margin: 0;
  color: #64748b;
  font-size: 15px;
}

/* Forms */
.profile-form,
.password-form,
.security-section {
  max-width: 600px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.form-group {
  margin-bottom: 24px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  display: block;
  margin-bottom: 10px;
  color: #334155;
  font-weight: 600;
  font-size: 14px;
}

.form-group input {
  width: 100%;
  padding: 14px 18px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 15px;
  transition: var(--transition);
  box-sizing: border-box;
  background: #f8fafc;
  color: #1e293b;
}

.form-group input:focus {
  outline: none;
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
}

.form-group input:disabled {
  background: #f1f5f9;
  color: #94a3b8;
  cursor: not-allowed;
}

.form-group small {
  display: block;
  margin-top: 8px;
  color: #94a3b8;
  font-size: 13px;
}

/* Buttons */
.btn-primary {
  padding: 14px 28px;
  background: var(--primary-gradient);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.btn-secondary {
  padding: 14px 28px;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3);
}

.btn-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(239, 68, 68, 0.4);
}

.btn-danger {
  padding: 14px 28px;
  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  box-shadow: 0 4px 15px rgba(249, 115, 22, 0.3);
}

.btn-danger:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(249, 115, 22, 0.4);
}

.btn-sm {
  padding: 10px 18px;
  font-size: 13px;
  border-radius: 10px;
}

/* Messages */
.error-message {
  background: linear-gradient(135deg, rgba(254, 226, 226, 0.9) 0%, rgba(254, 202, 202, 0.9) 100%);
  border: 1px solid #fecaca;
  color: #dc2626;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 24px;
  font-weight: 500;
}

.success-message {
  background: linear-gradient(135deg, rgba(220, 252, 231, 0.9) 0%, rgba(187, 247, 208, 0.9) 100%);
  border: 1px solid #bbf7d0;
  color: #16a34a;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 24px;
  font-weight: 500;
}

/* Security Section */
.security-section h2 {
  margin: 0 0 8px;
  color: #1e293b;
  font-size: 22px;
  font-weight: 700;
}

.security-section > p {
  margin: 0 0 24px;
  color: #64748b;
  font-size: 15px;
}

.two-factor-enabled {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  background: linear-gradient(135deg, rgba(220, 252, 231, 0.8) 0%, rgba(187, 247, 208, 0.8) 100%);
  border-radius: 16px;
  margin-bottom: 30px;
  border: 1px solid #bbf7d0;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 600;
  color: #16a34a;
}

.status-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #d1d5db;
}

.status-dot.active {
  background: #22c55e;
  box-shadow: 0 0 10px rgba(34, 197, 94, 0.5);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.2); opacity: 0.8; }
}

.two-factor-setup {
  margin-bottom: 30px;
}

.qr-setup {
  margin-top: 24px;
  padding: 24px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 16px;
  border: 1px solid #e2e8f0;
}

.qr-code {
  display: block;
  margin: 24px auto;
  max-width: 200px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.qr-setup code {
  display: block;
  margin-top: 12px;
  padding: 12px;
  background: white;
  border-radius: 8px;
  font-family: 'Fira Code', monospace;
  word-break: break-all;
  font-size: 13px;
  border: 1px solid #e2e8f0;
}

.logout-section {
  margin-top: 48px;
  padding-top: 32px;
  border-top: 2px solid #f1f5f9;
}

.logout-section h2 {
  margin: 0 0 8px;
  color: #1e293b;
  font-size: 20px;
  font-weight: 700;
}

.logout-section > p {
  margin: 0 0 20px;
  color: #64748b;
  font-size: 15px;
}

.profile-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 18px;
  color: #64748b;
}

/* Recordings Section */
.recordings-section h2,
.files-section h2 {
  margin: 0 0 8px;
  color: #1e293b;
  font-size: 22px;
  font-weight: 700;
}

.recordings-section > p,
.files-section > p {
  margin: 0 0 24px;
  color: #64748b;
  font-size: 15px;
}

.no-recordings,
.no-files {
  text-align: center;
  padding: 48px 24px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 16px;
  border: 2px dashed #e2e8f0;
}

.no-recordings p,
.no-files p {
  margin: 8px 0;
  color: #94a3b8;
  font-size: 15px;
}

.recordings-list,
.files-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.recording-item,
.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  background: white;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  transition: var(--transition);
}

.recording-item:hover,
.file-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  border-color: #667eea;
}

.recording-info h3,
.file-info h3 {
  margin: 0 0 8px;
  color: #1e293b;
  font-size: 16px;
  font-weight: 600;
}

.recording-info p,
.file-meta {
  margin: 4px 0;
  color: #64748b;
  font-size: 14px;
}

.recording-actions,
.file-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

/* Bouton Lire */
.btn-play {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  text-decoration: none;
}

.btn-play:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-play:active {
  transform: translateY(0);
}

/* Bouton Partager */
.btn-share {
  background: linear-gradient(135deg, #27ae60 0%, #2ecc71 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  text-decoration: none;
}

.btn-share:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(39, 174, 96, 0.3);
}

.btn-share:active {
  transform: translateY(0);
}

.btn-share:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Boutons petit taille (btn-sm) */
.btn-sm {
  padding: 6px 12px;
  font-size: 13px;
  border-radius: 6px;
}

/* Bouton Danger (Supprimer) */
.btn-danger {
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  text-decoration: none;
}

.btn-danger:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(231, 76, 60, 0.3);
}

.btn-danger:active {
  transform: translateY(0);
}

.btn-danger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.file-icon {
  font-size: 40px;
  margin-right: 16px;
}

.loading {
  text-align: center;
  padding: 32px;
  color: #64748b;
  font-size: 15px;
}

/* Video Player Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.video-modal {
  background: white;
  border-radius: 24px;
  padding: 32px;
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.3);
}

.video-modal h3 {
  margin: 0 0 20px;
  color: #1e293b;
  font-size: 24px;
  font-weight: 700;
}

.video-player {
  width: 100%;
  max-height: 450px;
  background: #000;
  border-radius: 16px;
  margin-bottom: 20px;
}

.video-info {
  margin: 20px 0;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 12px;
}

.video-info p {
  margin: 6px 0;
  color: #64748b;
  font-size: 14px;
}

/* Password Toggle Styles */
.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-wrapper input {
  padding-right: 45px !important; /* Space for the toggle button */
}

.password-toggle {
  position: absolute;
  right: 15px;
  background: none;
  border: none;
  color: #94a3b8;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: var(--transition);
}

.password-toggle:hover {
  color: #64748b;
  background: rgba(102, 126, 234, 0.1);
  border-radius: 8px;
}

.password-toggle:active {
  transform: scale(0.95);
}
.sidebar-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
}

/* Responsive */
@media (max-width: 1024px) {
  .profile-main {
    padding: 30px;
    max-width: 100%;
  }
  
  .form-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
   .mobile-menu-toggle {
     display: flex;
   }
   
   .profile-page {
     flex-direction: column;
   }
   
   .profile-sidebar {
     position: fixed;
     left: -300px;
     width: 280px;
     min-height: 100vh;
     transition: left 0.3s ease;
   }
   
   .profile-sidebar.open {
     left: 0;
     box-shadow: 10px 0 40px rgba(0, 0, 0, 0.2);
   }
   
   .sidebar-overlay {
     display: none;
     position: fixed;
     top: 0;
     left: 0;
     right: 0;
     bottom: 0;
     background: rgba(0, 0, 0, 0.5);
     z-index: 99;
   }
   
   .sidebar-overlay.visible {
     opacity: 1;
     visibility: visible;
   }
   
   .profile-main {
     padding: 80px 20px 30px;
     max-width: 100%;
   }
   
   .profile-content {
     padding: 24px;
     border-radius: 20px;
   }
   
   .profile-header h1 {
     font-size: 28px;
   }
   
   .profile-picture-section {
     flex-direction: column;
     text-align: center;
   }
   
   .profile-picture-container {
     width: 100px;
     height: 100px;
   }
   
   .profile-picture-info h3 {
     font-size: 22px;
   }
   
   .recording-item,
   .file-item {
     flex-direction: column;
     gap: 16px;
     align-items: flex-start;
   }
   
   .recording-actions,
   .file-actions {
     width: 100%;
     justify-content: flex-end;
   }
   
   .two-factor-enabled {
     flex-direction: column;
     gap: 16px;
     text-align: center;
   }
 }
 
/* Password Toggle Styles */
.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-wrapper input {
  padding-right: 45px !important; /* Space for the toggle button */
}

.password-toggle {
  position: absolute;
  right: 15px;
  background: none;
  border: none;
  color: #94a3b8;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: var(--transition);
}

.password-toggle:hover {
  color: #64748b;
  background: rgba(102, 126, 234, 0.1);
  border-radius: 8px;
}

.password-toggle:active {
  transform: scale(0.95);
}

@media (max-width: 480px) {
  .profile-main {
    padding: 70px 16px 24px;
  }
  
  .profile-content {
    padding: 20px;
    border-radius: 16px;
  }
  
  .profile-header h1 {
    font-size: 24px;
  }
  
  .form-group input {
    padding: 12px 14px;
    font-size: 14px;
  }
  
   .btn-primary,
   .btn-secondary,
   .btn-danger {
     width: 100%;
     justify-content: center;
   }
}

/* Password Toggle Styles for small screens */
@media (max-width: 480px) {
  .password-input-wrapper input {
    padding-right: 40px !important;
  }
  
  .password-toggle {
    width: 25px;
    height: 25px;
    right: 10px;
  }
  
  .password-toggle svg {
    width: 18px;
    height: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profile.css"],"names":[],"mappings":"AAAA;EACE,qEAAqE;EACrE,6CAA6C;EAC7C,+CAA+C;EAC/C,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,6DAA6D;EAC7D,UAAU;EACV,MAAM;AACR;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,+CAA+C;EAC/C,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,0CAA0C;EAC1C,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8FAA8F;EAC9F,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,qEAAqE;EACrE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,aAAa;EACb,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,UAAU;AACV;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,+FAA+F;EAC/F,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+FAA+F;EAC/F,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+FAA+F;EAC/F,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,WAAW,mBAAmB,EAAE,UAAU,EAAE;EAC5C,MAAM,qBAAqB,EAAE,YAAY,EAAE;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA,uBAAuB;AACvB;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;EAEE,2BAA2B;EAC3B,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B,EAAE,gCAAgC;AAClE;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;GACG;KACE,aAAa;GACf;;GAEA;KACE,sBAAsB;GACxB;;GAEA;KACE,eAAe;KACf,YAAY;KACZ,YAAY;KACZ,iBAAiB;KACjB,0BAA0B;GAC5B;;GAEA;KACE,OAAO;KACP,0CAA0C;GAC5C;;GAEA;KACE,aAAa;KACb,eAAe;KACf,MAAM;KACN,OAAO;KACP,QAAQ;KACR,SAAS;KACT,8BAA8B;KAC9B,WAAW;GACb;;GAEA;KACE,UAAU;KACV,mBAAmB;GACrB;;GAEA;KACE,uBAAuB;KACvB,eAAe;GACjB;;GAEA;KACE,aAAa;KACb,mBAAmB;GACrB;;GAEA;KACE,eAAe;GACjB;;GAEA;KACE,sBAAsB;KACtB,kBAAkB;GACpB;;GAEA;KACE,YAAY;KACZ,aAAa;GACf;;GAEA;KACE,eAAe;GACjB;;GAEA;;KAEE,sBAAsB;KACtB,SAAS;KACT,uBAAuB;GACzB;;GAEA;;KAEE,WAAW;KACX,yBAAyB;GAC3B;;GAEA;KACE,sBAAsB;KACtB,SAAS;KACT,kBAAkB;GACpB;CACF;;AAED,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B,EAAE,gCAAgC;AAClE;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;GAEC;;;KAGE,WAAW;KACX,uBAAuB;GACzB;AACH;;AAEA,6CAA6C;AAC7C;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[":root {\n  --primary-gradient: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  --card-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n  --hover-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n  --border-radius: 16px;\n  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.profile-page {\n  display: flex;\n  min-height: 100vh;\n  background: linear-gradient(180deg, #f8fafc 0%, #e2e8f0 100%);\n  padding: 0;\n  gap: 0;\n}\n\n/* Mobile Menu Toggle */\n.mobile-menu-toggle {\n  display: none;\n  position: fixed;\n  top: 20px;\n  left: 20px;\n  z-index: 1001;\n  width: 50px;\n  height: 50px;\n  border-radius: 12px;\n  background: var(--primary-gradient);\n  border: none;\n  color: white;\n  font-size: 24px;\n  cursor: pointer;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\n  align-items: center;\n  justify-content: center;\n  transition: var(--transition);\n}\n\n.mobile-menu-toggle:hover {\n  transform: scale(1.05);\n}\n\n.mobile-menu-toggle:active {\n  transform: scale(0.95);\n}\n\n/* Sidebar */\n.profile-sidebar {\n  width: 280px;\n  min-height: 100vh;\n  background: white;\n  box-shadow: 4px 0 30px rgba(0, 0, 0, 0.08);\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  overflow-y: auto;\n  flex-shrink: 0;\n  z-index: 100;\n  transition: var(--transition);\n}\n\n.sidebar-header {\n  padding: 30px 24px;\n  background: var(--primary-gradient);\n  color: white;\n  margin-bottom: 20px;\n}\n\n.sidebar-header h2 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.sidebar-header p {\n  margin: 8px 0 0;\n  font-size: 13px;\n  opacity: 0.9;\n}\n\n.sidebar-menu {\n  background: transparent;\n  overflow: visible;\n  padding: 0 16px;\n}\n\n.sidebar-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 18px;\n  color: #64748b;\n  text-decoration: none;\n  transition: var(--transition);\n  border-radius: 12px;\n  margin-bottom: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.sidebar-item:hover {\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\n  color: #667eea;\n  transform: translateX(4px);\n}\n\n.sidebar-item.active {\n  background: var(--primary-gradient);\n  color: white;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\n}\n\n.sidebar-item.active:hover {\n  transform: translateX(4px);\n}\n\n.sidebar-icon {\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: rgba(0, 0, 0, 0.05);\n  transition: var(--transition);\n}\n\n.sidebar-item.active .sidebar-icon {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.sidebar-divider {\n  height: 1px;\n  background: linear-gradient(90deg, transparent, #e2e8f0, transparent);\n  margin: 16px 24px;\n}\n\n.sidebar-section-title {\n  padding: 8px 24px;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: #94a3b8;\n  font-weight: 700;\n}\n\n/* Main Content */\n.profile-main {\n  flex: 1;\n  min-width: 0;\n  padding: 40px;\n  max-width: calc(100% - 280px);\n}\n\n.profile-header {\n  margin-bottom: 32px;\n}\n\n.profile-header h1 {\n  margin: 0 0 10px;\n  background: var(--primary-gradient);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-size: 36px;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n}\n\n.profile-header p {\n  margin: 0;\n  color: #64748b;\n  font-size: 16px;\n}\n\n.profile-content {\n  background: white;\n  border-radius: var(--border-radius);\n  padding: 32px;\n  box-shadow: var(--card-shadow);\n}\n\n/* Profile Picture */\n.profile-picture-section {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  margin-bottom: 32px;\n  padding-bottom: 32px;\n  border-bottom: 2px solid #f1f5f9;\n}\n\n.profile-picture-container {\n  width: 120px;\n  height: 120px;\n  border-radius: 24px;\n  overflow: hidden;\n  flex-shrink: 0;\n  border: 4px solid white;\n  box-shadow: 0 8px 30px rgba(102, 126, 234, 0.3);\n}\n\n.profile-picture {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.profile-picture-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--primary-gradient);\n  color: white;\n  font-size: 48px;\n  font-weight: 700;\n}\n\n.profile-picture-info h3 {\n  margin: 0 0 6px;\n  color: #1e293b;\n  font-size: 28px;\n  font-weight: 700;\n}\n\n.profile-picture-info p {\n  margin: 0;\n  color: #64748b;\n  font-size: 15px;\n}\n\n/* Forms */\n.profile-form,\n.password-form,\n.security-section {\n  max-width: 600px;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 24px;\n}\n\n.form-group {\n  margin-bottom: 24px;\n}\n\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 10px;\n  color: #334155;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 14px 18px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 15px;\n  transition: var(--transition);\n  box-sizing: border-box;\n  background: #f8fafc;\n  color: #1e293b;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #667eea;\n  background: white;\n  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);\n}\n\n.form-group input:disabled {\n  background: #f1f5f9;\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.form-group small {\n  display: block;\n  margin-top: 8px;\n  color: #94a3b8;\n  font-size: 13px;\n}\n\n/* Buttons */\n.btn-primary {\n  padding: 14px 28px;\n  background: var(--primary-gradient);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);\n}\n\n.btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.btn-secondary {\n  padding: 14px 28px;\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3);\n}\n\n.btn-secondary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(239, 68, 68, 0.4);\n}\n\n.btn-danger {\n  padding: 14px 28px;\n  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n  box-shadow: 0 4px 15px rgba(249, 115, 22, 0.3);\n}\n\n.btn-danger:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(249, 115, 22, 0.4);\n}\n\n.btn-sm {\n  padding: 10px 18px;\n  font-size: 13px;\n  border-radius: 10px;\n}\n\n/* Messages */\n.error-message {\n  background: linear-gradient(135deg, rgba(254, 226, 226, 0.9) 0%, rgba(254, 202, 202, 0.9) 100%);\n  border: 1px solid #fecaca;\n  color: #dc2626;\n  padding: 16px 20px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  font-weight: 500;\n}\n\n.success-message {\n  background: linear-gradient(135deg, rgba(220, 252, 231, 0.9) 0%, rgba(187, 247, 208, 0.9) 100%);\n  border: 1px solid #bbf7d0;\n  color: #16a34a;\n  padding: 16px 20px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  font-weight: 500;\n}\n\n/* Security Section */\n.security-section h2 {\n  margin: 0 0 8px;\n  color: #1e293b;\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.security-section > p {\n  margin: 0 0 24px;\n  color: #64748b;\n  font-size: 15px;\n}\n\n.two-factor-enabled {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  background: linear-gradient(135deg, rgba(220, 252, 231, 0.8) 0%, rgba(187, 247, 208, 0.8) 100%);\n  border-radius: 16px;\n  margin-bottom: 30px;\n  border: 1px solid #bbf7d0;\n}\n\n.status-indicator {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-weight: 600;\n  color: #16a34a;\n}\n\n.status-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: #d1d5db;\n}\n\n.status-dot.active {\n  background: #22c55e;\n  box-shadow: 0 0 10px rgba(34, 197, 94, 0.5);\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% { transform: scale(1); opacity: 1; }\n  50% { transform: scale(1.2); opacity: 0.8; }\n}\n\n.two-factor-setup {\n  margin-bottom: 30px;\n}\n\n.qr-setup {\n  margin-top: 24px;\n  padding: 24px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n}\n\n.qr-code {\n  display: block;\n  margin: 24px auto;\n  max-width: 200px;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.qr-setup code {\n  display: block;\n  margin-top: 12px;\n  padding: 12px;\n  background: white;\n  border-radius: 8px;\n  font-family: 'Fira Code', monospace;\n  word-break: break-all;\n  font-size: 13px;\n  border: 1px solid #e2e8f0;\n}\n\n.logout-section {\n  margin-top: 48px;\n  padding-top: 32px;\n  border-top: 2px solid #f1f5f9;\n}\n\n.logout-section h2 {\n  margin: 0 0 8px;\n  color: #1e293b;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.logout-section > p {\n  margin: 0 0 20px;\n  color: #64748b;\n  font-size: 15px;\n}\n\n.profile-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  font-size: 18px;\n  color: #64748b;\n}\n\n/* Recordings Section */\n.recordings-section h2,\n.files-section h2 {\n  margin: 0 0 8px;\n  color: #1e293b;\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.recordings-section > p,\n.files-section > p {\n  margin: 0 0 24px;\n  color: #64748b;\n  font-size: 15px;\n}\n\n.no-recordings,\n.no-files {\n  text-align: center;\n  padding: 48px 24px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-radius: 16px;\n  border: 2px dashed #e2e8f0;\n}\n\n.no-recordings p,\n.no-files p {\n  margin: 8px 0;\n  color: #94a3b8;\n  font-size: 15px;\n}\n\n.recordings-list,\n.files-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.recording-item,\n.file-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  background: white;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  transition: var(--transition);\n}\n\n.recording-item:hover,\n.file-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);\n  border-color: #667eea;\n}\n\n.recording-info h3,\n.file-info h3 {\n  margin: 0 0 8px;\n  color: #1e293b;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.recording-info p,\n.file-meta {\n  margin: 4px 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.recording-actions,\n.file-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n/* Bouton Lire */\n.btn-play {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.btn-play:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.btn-play:active {\n  transform: translateY(0);\n}\n\n/* Bouton Partager */\n.btn-share {\n  background: linear-gradient(135deg, #27ae60 0%, #2ecc71 100%);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.btn-share:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(39, 174, 96, 0.3);\n}\n\n.btn-share:active {\n  transform: translateY(0);\n}\n\n.btn-share:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Boutons petit taille (btn-sm) */\n.btn-sm {\n  padding: 6px 12px;\n  font-size: 13px;\n  border-radius: 6px;\n}\n\n/* Bouton Danger (Supprimer) */\n.btn-danger {\n  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.btn-danger:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(231, 76, 60, 0.3);\n}\n\n.btn-danger:active {\n  transform: translateY(0);\n}\n\n.btn-danger:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.file-icon {\n  font-size: 40px;\n  margin-right: 16px;\n}\n\n.loading {\n  text-align: center;\n  padding: 32px;\n  color: #64748b;\n  font-size: 15px;\n}\n\n/* Video Player Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.video-modal {\n  background: white;\n  border-radius: 24px;\n  padding: 32px;\n  max-width: 900px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.3);\n}\n\n.video-modal h3 {\n  margin: 0 0 20px;\n  color: #1e293b;\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.video-player {\n  width: 100%;\n  max-height: 450px;\n  background: #000;\n  border-radius: 16px;\n  margin-bottom: 20px;\n}\n\n.video-info {\n  margin: 20px 0;\n  padding: 16px 20px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-radius: 12px;\n}\n\n.video-info p {\n  margin: 6px 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n/* Password Toggle Styles */\n.password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input-wrapper input {\n  padding-right: 45px !important; /* Space for the toggle button */\n}\n\n.password-toggle {\n  position: absolute;\n  right: 15px;\n  background: none;\n  border: none;\n  color: #94a3b8;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  transition: var(--transition);\n}\n\n.password-toggle:hover {\n  color: #64748b;\n  background: rgba(102, 126, 234, 0.1);\n  border-radius: 8px;\n}\n\n.password-toggle:active {\n  transform: scale(0.95);\n}\n.sidebar-overlay {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 99;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .profile-main {\n    padding: 30px;\n    max-width: 100%;\n  }\n  \n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n   .mobile-menu-toggle {\n     display: flex;\n   }\n   \n   .profile-page {\n     flex-direction: column;\n   }\n   \n   .profile-sidebar {\n     position: fixed;\n     left: -300px;\n     width: 280px;\n     min-height: 100vh;\n     transition: left 0.3s ease;\n   }\n   \n   .profile-sidebar.open {\n     left: 0;\n     box-shadow: 10px 0 40px rgba(0, 0, 0, 0.2);\n   }\n   \n   .sidebar-overlay {\n     display: none;\n     position: fixed;\n     top: 0;\n     left: 0;\n     right: 0;\n     bottom: 0;\n     background: rgba(0, 0, 0, 0.5);\n     z-index: 99;\n   }\n   \n   .sidebar-overlay.visible {\n     opacity: 1;\n     visibility: visible;\n   }\n   \n   .profile-main {\n     padding: 80px 20px 30px;\n     max-width: 100%;\n   }\n   \n   .profile-content {\n     padding: 24px;\n     border-radius: 20px;\n   }\n   \n   .profile-header h1 {\n     font-size: 28px;\n   }\n   \n   .profile-picture-section {\n     flex-direction: column;\n     text-align: center;\n   }\n   \n   .profile-picture-container {\n     width: 100px;\n     height: 100px;\n   }\n   \n   .profile-picture-info h3 {\n     font-size: 22px;\n   }\n   \n   .recording-item,\n   .file-item {\n     flex-direction: column;\n     gap: 16px;\n     align-items: flex-start;\n   }\n   \n   .recording-actions,\n   .file-actions {\n     width: 100%;\n     justify-content: flex-end;\n   }\n   \n   .two-factor-enabled {\n     flex-direction: column;\n     gap: 16px;\n     text-align: center;\n   }\n }\n \n/* Password Toggle Styles */\n.password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input-wrapper input {\n  padding-right: 45px !important; /* Space for the toggle button */\n}\n\n.password-toggle {\n  position: absolute;\n  right: 15px;\n  background: none;\n  border: none;\n  color: #94a3b8;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  transition: var(--transition);\n}\n\n.password-toggle:hover {\n  color: #64748b;\n  background: rgba(102, 126, 234, 0.1);\n  border-radius: 8px;\n}\n\n.password-toggle:active {\n  transform: scale(0.95);\n}\n\n@media (max-width: 480px) {\n  .profile-main {\n    padding: 70px 16px 24px;\n  }\n  \n  .profile-content {\n    padding: 20px;\n    border-radius: 16px;\n  }\n  \n  .profile-header h1 {\n    font-size: 24px;\n  }\n  \n  .form-group input {\n    padding: 12px 14px;\n    font-size: 14px;\n  }\n  \n   .btn-primary,\n   .btn-secondary,\n   .btn-danger {\n     width: 100%;\n     justify-content: center;\n   }\n}\n\n/* Password Toggle Styles for small screens */\n@media (max-width: 480px) {\n  .password-input-wrapper input {\n    padding-right: 40px !important;\n  }\n  \n  .password-toggle {\n    width: 25px;\n    height: 25px;\n    right: 10px;\n  }\n  \n  .password-toggle svg {\n    width: 18px;\n    height: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
